import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import axios from 'axios';

function Certifications() {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const [isBrowser, setIsBrowser] = useState(false);
    const [certification, setCertification] = useState({ italianDocs: [], englishDocs: [] });
    const [selectedPdf, setSelectedPdf] = useState(null);
    const [activeItem, setActiveItem] = useState(null);
    const [filter, setFilter] = useState('');
    const [totalPages, setTotalPages] = useState(1);
  
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    
    const fetchCert = async (page = 1, allCertifications = []) => {
    if (!isBrowser) return;
    
    try {
        const response = await axios.get(`https://grec-backend.onrender.com/api/certifications?depth=1&page=${page}`);
        const certificationsList = [...allCertifications, ...response.data.docs];
        const totalPages = response.data.totalPages;

        const certifications = certificationsList.map(certification => ({
        ...certification,
        previewUrl: certification.anteprima ? `https://grec-backend.onrender.com/api/media/${certification.anteprima}` : null,
        docUrl: certification.anteprima ? `https://grec-backend.onrender.com/api/media/${certification.certificazione}` : null
        }));

        console.log(certifications)

        const sortedCertifications = certifications.sort((a, b) => a.order - b.order);

        const italianDocs = sortedCertifications.filter(doc => doc.language === 'it');
        const englishDocs = sortedCertifications.filter(doc => doc.language === 'en');

        setCertification({ italianDocs, englishDocs });
        setTotalPages(totalPages);

        if (page < totalPages) {
        fetchCert(page + 1, certificationsList);
        }
    } catch (error) {
        console.error('Error fetching certifications:', error);
    }
    };

    useEffect(() => {
    if (isBrowser) {
        fetchCert();
    }
    }, [isBrowser]);

    const handleCertification = (filePath, fileName) => {
        if (isBrowser) {
            const link = document.createElement('a');
            link.href = filePath;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const filteredItalianDocs = useMemo(() => 
        certification.italianDocs.filter(doc => doc.title.toLowerCase().includes(filter.toLowerCase())),
        [certification.italianDocs, filter]
      );
    
      const filteredEnglishDocs = useMemo(() => 
        certification.englishDocs.filter(doc => doc.title.toLowerCase().includes(filter.toLowerCase())),
        [certification.englishDocs, filter]
      );

    
      
  const DocumentList = ({ docs, title, img }) => (
    <div className="grec-document-list">
      <div className='grec-document-list-title'>
        <img style={{ height: '30px' }} src={img} alt={title} />
        <h2 id={title === `Certificazioni` ? `titoloIT` : `titleEN`}>{title}</h2>
      </div>
      <div className="grec-documents-container">
        {docs.map((document, index) => (
            <div key={index}>
                <img className='certifications__img-card' src={document.previewUrl} alt={`Certification ${document.title}`} />
                <button onClick={() => handleCertification(document.docUrl, document.title)} className="download-button">
                    {currentLanguage === 'it' ? 'Scarica la Certificazione' : 'Download Certification'}
                </button>
            </div>
        ))}
      </div>
    </div>
  );
  //onClick={ handleCertification(document.docUrl, document.title)} 

    return (
        <>
            <section className='page--container mt-fix'>
                <div className='gradient-page'>
                    <div className='Grec-title-container'>
                        <h1>{currentLanguage === 'it' ? 'CERTIFICAZIONI' : 'CERTIFICATIONS'}</h1>

                        {currentLanguage === 'it' ? <>
                        
                        <p>
                            GREC ha acquisito la certificazione ISO 9001.
                            <br/><br/>
                            <img className='certifications__logo' src="/certifications/en_9001.png" alt="TÜV Thüringen Italia ISO 9001:2015" /><br/><br/>
                            La ISO 9001 affronta la conformità alla norma internazionale ad adesione volontaria relativa alla "Gestione per la Qualità" dei servizi prestati e dei lavori effettuati.
                            <br/><br/>
                            La ISO 9001 pone al centro del sistema di gestione aziendale il cliente e la sua piena soddisfazione; la visione dell'azienda come un insieme di processi posti in stretta relazione tra loro e finalizzati alla costante rispondenza dei servizi e dei lavori a requisiti predeterminati; l'importanza di perseguire il miglioramento continuativo delle prestazioni aziendali. Qualità significa gestire l'efficacia e l'efficienza dei processi aziendali attraverso la conoscenza, la gestione e il monitoraggio dei processi.
                        </p>
                        </> : <>  <p>
                            GREC has acquired ISO 9001 certification.
                            <br/><br/>
                            <img className='certifications__logo' src="/certifications/en_9001.png" alt="TÜV Thüringen Italia ISO 9001:2015" /><br/><br/>
                            ISO 9001 addresses compliance with the international voluntary standard related to "Quality Management" for services provided and work performed.
                            <br/><br/>
                            ISO 9001 places the customer and their full satisfaction at the center of the company's management system; it views the company as a set of processes that are closely interconnected and aimed at ensuring the constant conformity of services and work to predetermined requirements. The importance of pursuing continuous improvement in the company's performance is also emphasized. Quality means managing the effectiveness and efficiency of company processes through knowledge, management, and monitoring of those processes.
                        </p>
                        </>}


                      
                    </div>

                    <div className="cont-btn-lang-cert">
                        <a href="#titoloIT" className="btn-lang-cert" title="vai alle certificazioni in italiano">
                            <img src="/icons/italy-circular.svg" alt="vai alle certificazioni in italiano" />
                        </a>
                        <a  href="#titleEN" className="btn-lang-cert" title="go gto English certifications">
                            <img src="/icons/great-britain-circular.svg" alt="go gto English certifications" />
                        </a>
                    </div>

                    <div className='certifications'>
                        <DocumentList docs={filteredItalianDocs} title={`Certificazioni`} img="/icons/italy-circular.svg" />
                        <DocumentList docs={filteredEnglishDocs} title={`Certifications`} img="/icons/great-britain-circular.svg" /> 
    
                    </div>
                </div>
            </section>
        </>
    );
}

export default Certifications;